import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  const links = [
    { href: "#about", label: "About" },
    { href: "#services", label: "Services" },
    { href: "#booking", label: "Book" },
    { href: "#faq", label: "FAQ" },
    { href: "#contact", label: "Contact" },
  ];
  return (
    <footer className="bg-background border-t border-border/60 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2 mb-5">
              <span className="w-9 h-9 rounded-full bg-gradient-to-br from-primary to-secondary inline-flex items-center justify-center text-secondary-foreground font-serif text-lg">e</span>
              <span className="font-serif text-2xl">Epic Heal</span>
            </a>
            <p className="text-muted-foreground max-w-sm leading-relaxed">
              Personalised Spinal Flow sessions in the comfort of your home — for those ready to come home to themselves.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.22em] text-secondary mb-4">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              {links.map((l) => (
                <li key={l.href}><a href={l.href} className="text-muted-foreground hover:text-foreground transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-secondary mb-4">Latest</h4>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li>Instagram feed</li>
              <li>Blog & articles</li>
              <li>Coming soon</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-secondary mb-4">Follow</h4>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-full border border-border/60 flex items-center justify-center hover:bg-card"><Instagram size={15}/></a>
              <a href="#" className="w-10 h-10 rounded-full border border-border/60 flex items-center justify-center hover:bg-card"><Facebook size={15}/></a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-border/40 flex flex-col sm:flex-row gap-4 justify-between items-center text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Epic Heal. Made with care.</p>
          <p className="max-w-md text-center sm:text-right">
            Wellness disclaimer: Spinal Flow is a complementary practice and not a substitute for medical care. Please consult a qualified healthcare provider for medical conditions.
          </p>
        </div>
      </div>
    </footer>
  );
}
